import React from 'react';
import AcquisitionOptions from './AcquisitionOptions/AcquisitionOptions';
import MeetUpOption from './AcquisitionOptions/MeetupOption';
import PickUpOption from './AcquisitionOptions/PickupOption';

import Cta from './Cta';

import CityStateInfo from './LocationDisplay/CityStateInfo';
import LocationDisplay from './LocationDisplay/LocationDisplay';

import LocationInputForm from './LocationInputForm/FormWrapper';

import { useLocationContext } from '../context/LocationContext';
import getFormHeading from '../lib/getFormHeading';
import maybeErrored from '../lib/maybeErrored';

export default function UndeliverableContent() {
  const { isDeliveryAllowed = true, errorState, isExcludedLocation } = useLocationContext();
  const hasErrored = maybeErrored(errorState);
  const formHeading = getFormHeading({ hasErrored, isExcludedLocation, isDeliveryAllowed })
  
  const ctaText = isExcludedLocation ? 'Delivery Is Unavailable In Your Area' : "Delivery Is Unavailable, But You Still Have Options"

  return !isDeliveryAllowed ? (
    <>
      <Cta ctaText={ctaText} />
      <LocationDisplay>
        <CityStateInfo />
        <AcquisitionOptions>
          <PickUpOption />
          <MeetUpOption />
        </AcquisitionOptions>
      </LocationDisplay>
      <LocationInputForm formHeading={formHeading} />
    </>
  ) : null;
}
